import {createContext, useContext} from "react";
import {PaymentDetails} from "@bounce/shared/consumer/declarations";
import {IAccountFlexUIState, SaveFlexUIField} from "./types";

export interface FlexUiStateContextProps {
  saveFlexUIField: SaveFlexUIField;
  saveFlexPaymentDetails: (paymentDetails: PaymentDetails) => void;
  clearAccountFlexState: () => void;
  getAccountState: () => IAccountFlexUIState | undefined;
  shouldStoreFlexUI: boolean;
}

const FlexUiStateContext = createContext<FlexUiStateContextProps>(undefined!);

const useFlexUiState = (): FlexUiStateContextProps => {
  const context = useContext(FlexUiStateContext);

  if (!context) throw new Error("FlexUiStateContext must be used inside FlexUiStateProvider");

  return context;
};

export {FlexUiStateContext, useFlexUiState};
